import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/Index/Index.vue'
import contact from '../views/contact/contact.vue'
import services from '../views/services/services.vue'
import SearchPage from '../views/SearchPage.vue'
import About from '../views/about/About.vue'
import Honor from '../views/about/Honor.vue'
import News from '../views/news/News.vue'
import Newsnew from '../views/news/Newsnew.vue'
import Newsmsg from '../views/news/Newsmsg.vue'
import NewsDetail from '../views/news/NewsDetail.vue'
import Join from '../views/join/join.vue'
import JoinWelcome from '../views/join/joinWelcome.vue'
import JoinRecruit from '../views/join/joinRecruit.vue'
import JoinDetail from '../views/join/joinDetail.vue'
import Investor from '../views/Investor/Investor.vue'
import Shares from '../views/Investor/shares.vue'
import Finance from '../views/Investor/finance.vue'
import Basic from '../views/Investor/Basic.vue'
import Market from '../views/Investor/market.vue'
import tenInvestors from '../views/Investor/tenInvestors.vue'
import year from '../views/Investor/year.vue'
import quarter from '../views/Investor/quarter.vue'
import notice from '../views/Investor/notice.vue'
import timing from '../views/Investor/timing.vue'
import temporary from '../views/Investor/temporary.vue'
import interaction from '../views/Investor/interaction.vue'
import servicesList from '../views/services/servicesList.vue'
import category from '../views/services/category.vue'
import servicesDetail from '../views/services/servicesDetail.vue'
import online from '../views/contact/online.vue'
import contactInformation from '../views/contact/contactInformation'
import contactEngineer from '../views/contact/contactEngineer'
import mapAbout from '../views/map/map_About.vue'
import legal from '../views/statement/Legal.vue'
import privacy from '../views/statement/Privacy.vue'
Vue.use(VueRouter)

export default new VueRouter({
  routes: [
    { path: '/', redirect: '/index' },
    { path: '/index', name: '首页', component: Index },
    { path: '/searchpage', name: '搜索页', component: SearchPage },
    { path: '/about', name: '关于我们', component: About },
    { path: '/about/honor', name: '企业荣誉', component: Honor },
    { path: '/news', name: '新闻中心', component: News },
    { path: '/news/new', name: '公司新闻', component: Newsnew },
    { path: '/news/msg', name: '行业资讯', component: Newsmsg },
    { path: '/news/detail', name: '', component: NewsDetail },
    { path: '/join', name: '加入我们', component: Join },
    { path: '/join/welcome', name: '欢迎致辞', component: JoinWelcome },
    { path: '/join/recruit', name: '招聘岗位', component: JoinRecruit },
    { path: '/join/detail', name: 'joinDetail', component: JoinDetail },
    { path: '/investor', name: '投资者关系', component: Investor },
    { path: '/investor/shares', name: '股票信息', component: Shares },
    { path: '/investor/shares/basic', name: '基础信息', component: Basic },
    { path: '/investor/shares/market', name: '市场信息', component: Market },
    {
      path: '/investor/shares/tenInvestors',
      name: '十大股东',
      component: tenInvestors,
    },
    { path: '/investor/finance', name: '财务信息', component: Finance },
    { path: '/investor/finance/year', name: '年度信息', component: year },
    { path: '/investor/finance/quarter', name: '季度信息', component: quarter },
    { path: '/investor/notice', name: '公司公告', component: notice },
    {
      path: '/investor/notice/temporary',
      name: '临时公告',
      component: temporary,
    },
    { path: '/investor/notice/timing', name: '定期公告', component: timing },
    {
      path: '/investor/interaction',
      name: '投资者互动',
      component: interaction,
    },
    { path: '/services', name: '产品与服务', component: services },
    {
      path: '/services/servicesList',
      name: 'serviceslist',
      component: servicesList,
    },
    {
      path: '/services/servicesList/category',
      name: 'category',
      component: category,
    },
    {
      path: '/services/servicesList/category/detail',
      name: '',
      component: servicesDetail,
    },
    { path: '/contact', name: '联系我们', component: contact },
    {
      path: '/contact/contactEngineer',
      name: '售前、售后工程师',
      component: contactEngineer,
    },
    {
      path: '/contact/contactInformation',
      name: '联系方式',
      component: contactInformation,
    },
    { path: '/contact/online', name: '在线留言', component: online },
    { path: '/map/about', name: '站点地图', component: mapAbout },
    { path: '/statement/legal', name: '法律声明', component: legal },
    { path: '/statement/privacy', name: '隐私声明', component: privacy },
  ],
})
